import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOut } from '@fortawesome/free-solid-svg-icons';

import { LoggedUserContext } from '../../contexts/logged-user-context';
import ModalSelecionarEquipe from '../../components/modal-selecionar-equipe';

import LoginService from '../../services/login-service';

import './styles.scss';

export default function Header({ lock, forceSelecionarEquipe }) {
  const [userData, _] = React.useContext(LoggedUserContext);
  const [showModal, setShowModal] = React.useState(false);

  const onClickToggler = () => {
    window.changeMenuState();
  };

  async function logout() {
    window.showLoader();

    localStorage.clear();

    await LoginService.logoutAsync();

    window.location = '/login';

    window.hideLoader();
  }

  // const onClickToggler = () => {
  //   window.changeMenuState();
  // };

  return (
    <header className="header-nav active-menu">
      <nav className=" navbar navbar-expand-lg navbar-dark">
        <div className="container-fluid">
          <div className="row w-100 header-main">
            <div className="col-sm-12 col-md-auto">
              {/* <div className='row'>
								<div className='col-auto'></div>
								<div className='col text-end'>
									<div className='d-inline d-md-none'>
										<ul className='navbar-nav ms-auto '>
											<li className='nav-item'>
												<button
													type='button'
													className='btn btn-link text-white'
													onClick={logout}
												>
													<FontAwesomeIcon
														icon={faSignOut}
													/>
												</button>
											</li>
										</ul>
									</div>
								</div>
							</div> */}
            </div>

            {lock ? (
              <></>
            ) : (
              <div
                className="col"
                style={{
                  backgroundColor: 'white',
                  padding: '8px 10px',
                  borderRadius: '20px',
                  boxShadow: '5px 5px 10px rgba(0, 0, 0, 0.5)'
                }}
              >
                <div className="header-main">
                  <div className="">
                    <div className="header-nome ps-2">
                      <div className="d-flex align-items-left">
                        <div className="">
                          <button
                            type="button"
                            className="me-4 btn-header p-0"
                            onClick={onClickToggler}
                          >
                            <span className="navbar-toggler-icon">
                              <FontAwesomeIcon icon={faBars} />
                            </span>
                          </button>
                        </div>
                        {/* <img className="header-logo" src={userData?.logo} alt="logo" /> */}
                        {/* <img
                          className="header-logo"
                          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6mYmC0beppa90bZtatJWbZMTaMiEkuD_rGdgcIFE7SkEDnPLjzPoa-_nxLZq64Oy2HA8&usqp=CAU"
                          alt="logo"
                          style={{ width: '50px', height: 'auto', objectFit: 'contain' }}
                        /> */}
                      </div>
                      <div>
                        <span className="user-conectado">{userData?.nome}</span>
                        {userData?.equipes?.length > 0 && (
                          <small onClick={() => setShowModal(true)}>Acessar o time</small>
                        )}
                      </div>
                    </div>

                    {userData?.equipes?.length > 0 && userData?.equipe?.nome && (
                      <div className="pt-3">
                        <span> Acessando {userData?.equipe?.nome}</span>
                      </div>
                    )}
                  </div>
                  <div className="logout-btn">
                    <button
                      type="button"
                      className="btn"
                      onClick={logout}
                      // style={{ color: 'white', background: '#f54b01' }}
                    >
                      <span>Sair</span>
                      <FontAwesomeIcon icon={faSignOut} />{' '}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>

      <ModalSelecionarEquipe
        showModal={showModal || forceSelecionarEquipe}
        setShowModal={setShowModal}
      />
    </header>
  );
}
